/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DomainType,
  InclinometryBody,
  InclinometryBodyXYZOnly,
  InclinometryHeader,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectInclinometryClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение списка идентификаторов инклинометрий скважины
   * @request GET:/geology/project/{projectId}/Inclinometry/for_well/{wellId}
   * @secure
   */
  projectInclinometryGetInclinometryIdsForWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/geology/project/${projectId}/Inclinometry/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение заголовка инклинометрии по идентификатору
   * @request GET:/geology/project/{projectId}/Inclinometry/{inclinometryId}
   * @secure
   */
  projectInclinometryGetInclinometryHeader = (
    projectId: string,
    inclinometryId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryHeader, any>({
      path: `/geology/project/${projectId}/Inclinometry/${inclinometryId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение заголовка активной инклинометрии для скважины
   * @request GET:/geology/project/{projectId}/Inclinometry/for_well/{wellId}/active-header
   * @secure
   */
  projectInclinometryGetInclinometryHeaderForWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryHeader, any>({
      path: `/geology/project/${projectId}/Inclinometry/for_well/${wellId}/active-header`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение тела инклинометрии (точки и углы) по идентификатору
   * @request GET:/geology/project/{projectId}/Inclinometry/{inclinometryId}/data
   * @secure
   */
  projectInclinometryGetInclinometryBody = (
    projectId: string,
    inclinometryId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryBody, any>({
      path: `/geology/project/${projectId}/Inclinometry/${inclinometryId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение тела инклинометрии скважины в заданном домене
   * @request GET:/geology/project/{projectId}/Inclinometry/well/{wellId}/data/{domainType}
   * @secure
   */
  projectInclinometryGetInclinometryBodyInDomain = (
    projectId: string,
    wellId: string,
    domainType: DomainType,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryBody, any>({
      path: `/geology/project/${projectId}/Inclinometry/well/${wellId}/data/${domainType}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение тела инклинометрии (только координаты - атрибуты x, y, zabs) по идентификатору скважины
   * @request GET:/geology/project/{projectId}/Inclinometry/well/{wellId}/data/xyz-only
   * @secure
   */
  projectInclinometryGetInclinometryBodyXyzOnlyForWell = (
    projectId: string,
    wellId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryBodyXYZOnly, any>({
      path: `/geology/project/${projectId}/Inclinometry/well/${wellId}/data/xyz-only`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Получение среза тела инклинометрии (только координаты - атрибуты x, y, zabs) по идентификатору
   * @request GET:/geology/project/{projectId}/Inclinometry/{inclinometryId}/data/xyz-only
   * @secure
   */
  projectInclinometryGetInclinometryBodyXyzOnly = (
    projectId: string,
    inclinometryId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryBodyXYZOnly, any>({
      path: `/geology/project/${projectId}/Inclinometry/${inclinometryId}/data/xyz-only`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectInclinometry
   * @summary Добавление инклинометрии в проект из непроектных данных по списку идентификаторов инклинометрии
   * @request POST:/geology/project/{projectId}/Inclinometry
   * @secure
   */
  projectInclinometryAddInclinometryToProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/geology/project/${projectId}/Inclinometry`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
 * No description
 * 
 * @tags ProjectInclinometry
 * @summary Удалит инклинометрии из проекта, не удаляя сами инклинометрии из БД.
(пока флаг активности не используется)
 * @request PATCH:/geology/project/{projectId}/Inclinometry/remove
 * @secure
 */
  projectInclinometryRemoveInclinometriesFromProject = (
    projectId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<number, any>({
      path: `/geology/project/${projectId}/Inclinometry/remove`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
